import Dictionary from "./Dictionary";
import Footer from "./Footer";

import "./App.css";

function App() {
  return (
    <div className="App">
      <Dictionary />
      <Footer />
    </div>
  );
}

export default App;
